"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const styles_2 = require("../styles");
const ICON_SPACING = '0.4em';
const getFilledButton = (backgroundColor, borderColor, color) => ({
    backgroundColor,
    borderColor,
    color,
    '&:hover, &$hovered': {
        backgroundColor: styles_2.darken(backgroundColor, 0.05)
    },
    '&:active, &$active': {
        backgroundColor: styles_2.darken(backgroundColor, 0.25),
        borderColor: styles_2.darken(backgroundColor, 0.25)
    }
});
exports.default = ({ palette, typography, transitions }) => styles_1.createStyles({
    root: {
        position: 'relative',
        textTransform: 'none',
        fontSize: typography.button.fontSize,
        padding: '.4em 1em',
        borderRadius: '.25rem',
        lineHeight: '1.5em',
        transition: `all ${transitions.duration.short}ms ${transitions.easing.easeOut}`,
        transitionProperty: 'border, color, background',
        border: `solid 1px ${palette.grey[50]}`,
        backgroundColor: palette.grey[50],
        '&:hover, &$hovered': {
            backgroundColor: styles_2.darken(palette.grey[50], 0.05)
        },
        '&[disabled]': {
            opacity: 0.45
        },
        '&:focus, &$focused': {
            textDecoration: 'underline',
            '&:active, &$active, &:hover': {
                textDecoration: 'none'
            }
        },
        '&:active, &$active': {
            backgroundColor: styles_2.darken(palette.grey[50], 0.15)
        },
        '&+&': {
            marginLeft: '0.5em'
        }
    },
    loader: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)'
    },
    // sizes
    small: {
        fontSize: '0.8rem'
    },
    large: {
        fontSize: '1.2rem'
    },
    // Variants
    primary: getFilledButton(palette.primary.main, palette.primary.main, palette.common.white),
    secondary: Object.assign({}, getFilledButton('transparent', palette.primary.main, palette.primary.main), { '&:hover, &$hovered': {
            backgroundColor: palette.primary.light,
            borderColor: palette.primary.main
        }, '&:active, &$active': {
            backgroundColor: styles_2.darken(palette.primary.light, 0.25),
            borderColor: styles_2.darken(palette.primary.light, 0.25)
        } }),
    success: getFilledButton(palette.success.main, palette.success.main, palette.common.white),
    error: getFilledButton(palette.error.main, palette.error.main, palette.common.white),
    flat: Object.assign({}, getFilledButton(palette.common.white, palette.grey[50], palette.text.primary), { border: 'none' }),
    basic: getFilledButton(palette.common.white, palette.grey[50], palette.text.primary),
    // Other props
    fullWidth: {
        width: '100%'
    },
    hovered: {},
    focused: {},
    active: {},
    circular: {
        borderRadius: '50%',
        padding: '.4em'
    },
    // Child elements
    icon: {
        fontSize: '1.2em !important'
    },
    iconLeft: {
        marginRight: ICON_SPACING
    },
    iconRight: {
        marginLeft: ICON_SPACING
    },
    hidden: {
        opacity: 0
    }
});
//# sourceMappingURL=styles.js.map